import React, { useEffect } from "react";
import { initCherrySections } from "@/lib/cherry";

/** Embedded Cherry payment-plan widget for the Financing page. */
export function CherrySection() {
  useEffect(() => {
    initCherrySections();
  }, []);
  return (
    <div data-testid="cherry-widget-section" className="max-w-[1100px] mx-auto px-5 lg:px-10">
      <div id="all" />
      <div id="hero" className="mb-5" />
      <div id="calculator" className="mb-5" />
      <div id="howitworks" className="mb-5" />
      <div id="testimony" className="mb-5" />
      <div id="faq" className="mb-5" />
    </div>
  );
}
